firebird.factory('videoRecordAttachService', [
    'logService',
    'attendeeService',
    'localizationService',
    'videoGlobalService',
    function (logService, attendeeService, localizationService, videoGlobalService) {
        const logger = logService.createLoggerWithSource('videoRecordAttachService');
        var service = {
            initialize: initialize
        };

        var self, $scope;

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            self.sendVideoToFS = false; // whether the conference participants should send video to FreeSwitch
            self.sendScreenVideoToFS = false; // whether to send screen video to FreeSwitch

            self.attachVideoRoomToSIP = attachVideoRoomToSIP;

            // If true, SFU should send video to MCU (FS) too. This is sent by the node server,
            // when the call has recording, or has mobile or verto users. In that case video should
            // be sent to FreeSwitch, and it must use video codec of VP8 or H264 for it to work.
            // If attribute is initialized as true, then do not change its value on the event.
            self.onSendVideoToFS = onSendVideoToFS;
            $scope.$on('send-video-to-fs', self.onSendVideoToFS);
        }

        // attach or detach video room publisher to SIP, so that video packets from video room is forwarded
        // via SIP call to MCU.
        function attachVideoRoomToSIP(value, is_screen) {
            if (self.mediapath == 'sfu') {
                logger.log('videoroomCtrl attachvideoroom ignored for mediapath=' + self.mediapath);
            } else if (!is_screen && self.sipcall && self.mypvtid) {
                logger.log(
                    'videoroomCtrl attachvideoroom video value=' +
                        value +
                        ' room=' +
                        self.myroom +
                        ' private_id=' +
                        self.mypvtid
                );
                self.sipcall.send({
                    message: {
                        request: value ? 'attachvideoroom' : 'detachvideoroom',
                        room: self.myroom,
                        private_id: self.mypvtid
                    }
                });
                self.sipcall.state.attached = !!value;
            } else if (is_screen && self.screensipcall && self.screenpvtid) {
                logger.log(
                    'videoroomCtrl attachvideoroom screen value=' +
                        value +
                        ' room=' +
                        self.myroom +
                        ' private_id=' +
                        self.screenpvtid
                );
                self.screensipcall.send({
                    message: {
                        request: value ? 'attachvideoroom' : 'detachvideoroom',
                        room: self.myroom,
                        private_id: self.screenpvtid
                    }
                });
                self.screensipcall.state.attached = !!value;
            } else {
                logger.log('videoroomCtrl attachvideoroom ignored value=' + value + ' is_screen=' + is_screen);
            }
        }

        function onSendVideoToFS(evt, msg) {
            logger.log('videoroomCtrl onSendVideoToFS ' + msg.value);
            self.sendVideoToFS = msg.value;
            self.sendScreenVideoToFS = msg.screen === undefined ? msg.value : msg.screen; // same as value if screen is missing, otherwise use screen.

            self.attachVideoRoomToSIP(self.sendVideoToFS);
            self.attachVideoRoomToSIP(self.sendScreenVideoToFS, true);

            // if video is being published, change the codec if needed.
            if (self.videocodec == 'auto' && self.videoroom) {
                logger.log('videoroomCtrl re-creating offer to change video codec in auto mode');
                self.msgflowEvent('peer-connection:codec', {
                    type: 'video-send',
                    reason: 'auto-codec change on send-video-to-fs'
                });
                self.createOfferForVideo(undefined, function (status) {
                    if (!status) {
                        logger.log('videoroomCtrl stopping video publish due to error');
                        attendeeService.toggleVideoOff(
                            localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.YOU_CAMERA_TURNED_OFF')
                        );
                    } else {
                        // inform all the other attendees to restart our video feed.
                        self.sendRestartVideoPlay();
                    }
                });
            }

            // // re-subscribe all the playing video streams
            // // TODO: this does not work because of timing - subscriber won't know when the publisher
            // // is ready with the new stream. Hence this logic is done via attendee-message to each
            // // attendee, when this publisher is ready with new stream. Keeping the code here for future,
            // // if this can be fixed in some way, it will be simpler than the current logic.
            // var list = attendeeListService.getAttendeeList();
            // if (list) {
            //     list.forEach(function(attendee) {
            //         if (attendee) {
            //             if (attendee.attendantId != self.attendantId) {
            //                 logger.log('videoroomCtrl re-starting video play of ' + attendee.attendantId);
            //                 if (!attendee.isVideoMuted && self.feeds[attendee.attendantId]) {
            //                     self.stopVideoPlay(attendee.attendantId);
            //                     $timeout(function() {
            //                         self.startVideoPlay(attendee.attendantId);
            //                     }, 2000);
            //                 }
            //             }
            //         }
            //     });
            // }
        }
    }
]);
